<template>
  <svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M8.33337 1.66666L7.50004 2.49999H4.16671C3.70671 2.49999 3.33337 2.87332 3.33337 3.33332C3.33337 3.79332 3.70671 4.16666 4.16671 4.16666H5.83337H14.1667H15.8334C16.2934 4.16666 16.6667 3.79332 16.6667 3.33332C16.6667 2.87332 16.2934 2.49999 15.8334 2.49999H12.5L11.6667 1.66666H8.33337ZM4.16671 5.83332V16.6667C4.16671 17.5875 4.91254 18.3333 5.83337 18.3333H14.1667C15.0875 18.3333 15.8334 17.5875 15.8334 16.6667V5.83332H4.16671Z"
      fill="currentColor"></path>
  </svg>
</template>
